export default {
  galleries: [],
};
